import styled from "styled-components";
import { Paragraph } from "../styled/Text";
import { Row } from "../styled/Flex";

export const ViewMore = styled.div`
  position: absolute;
  color: black;
  display: flex;
  width: 100%;
  height: 100%;
  opacity: 0;
  align-items: center;
  justify-content: center;
`;

export const WrappedRow = styled(Row)`
  position: relative;
  margin-top: 15px;
  &:hover {
    cursor: pointer;
    transition: 0.25s all ease;

    ${Paragraph} {
      opacity: 0.25;
    }

    ${ViewMore} {
      opacity: 1 !important;
      transition: 0.25s all ease;
    }
  }
`;
